import React from "react";
import Chart from "react-apexcharts";

function LegendDot({ className, label, value }) {
  const dotClass = [
    "inline-block w-3 h-3 rounded-full",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className="flex items-center gap-3 text-slate-700">
      <span className={dotClass} />
      <span className="text-sm">{label}</span>
      <span className="font-semibold">{value}</span>
    </div>
  );
}

const Donut = ({
  solved = 0,
  quiz = 0,
  contest = 0,
  totalPrize = "₹1,250",
}) => {
  const series = [solved, quiz, contest];

  const options = {
    chart: {
      type: "donut",
    },
    labels: ["Solved", "Quiz", "Contest"],
    colors: ["#4F46E5", "#22C55E", "#F97316"],
    legend: {
      show: false, // ❌ apex legend band
    },
    dataLabels: {
      enabled: true,
    },
    plotOptions: {
      pie: {
        donut: {
          size: "70%",
          labels: {
            show: true,
            total: {
              show: true,
              label: "Total",
              fontSize: "16px",
              fontWeight: 600,
            },
          },
        },
      },
    },
    tooltip: {
      y: {
        formatter: (val) => `${val}%`,
      },
    },
    stroke: {
      width: 3,
      colors: ["#fff"],
    },
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center">
      {/* Chart */}
      <Chart options={options} series={series} type="donut" height={220} />

      {/* Text / Legend */}
      <div className="space-y-3">
        <LegendDot
          className="bg-indigo-600"
          label="Total Solved Questions"
          value={solved}
        />
        <LegendDot
          className="bg-green-500"
          label="Total Quiz Earnings"
          value={quiz}
        />
        <LegendDot
          className="bg-orange-500"
          label="Total Contest Earnings"
          value={contest}
        />

        <p className="pt-2 text-slate-700 font-semibold">
          Total Prize{" "}
          <span className="font-extrabold text-slate-900">
            {totalPrize}
          </span>
        </p>
      </div>
    </div>
  );
};

export default Donut;
